import { gql } from '@apollo/client';
import UNREVIEWED_REPORT_FRAGMENT from '../fragments/unreviewedReportFragment';

const UNREVIEWED_REPORTS_QUERY = gql`
  query unreviewedReports($filter: UnreviewedReportsFilterInput, $limit: Int) {
    unreviewedReports(filter: $filter, limit: $limit) {
      ...UnreviewedReportFragment
    }
  }

  ${UNREVIEWED_REPORT_FRAGMENT}
`;

export default UNREVIEWED_REPORTS_QUERY;
